import React, { Component } from "react";
import BreadCrumbs from "../../Elements/BreadCrumbs/BreadCrumbs";

export default class Top extends Component {
    getArchiveFallback(pathname, existingBreadcrumbs) {
        if (!pathname) {
            return null;
        }

        const fallbackConfigs = [
            {
                matcher: /\/koncerty\/archiwum(\/|$)/,
                label: "Koncerty - kategorie",
                url: "/pl/koncerty/kategorie"
            },
            {
                matcher: /\/concerts\/archive(\/|$)/,
                label: "Concerts - categories",
                url: "/en/concerts/categories"
            }
        ];

        const match = fallbackConfigs.find(config => config.matcher.test(pathname));

        if (!match) {
            return null;
        }

        const alreadyHasMatch =
            Array.isArray(existingBreadcrumbs) &&
            existingBreadcrumbs.some(item => item && item.url === match.url);

        if (alreadyHasMatch) {
            return null;
        }

        return { name: match.label, url: match.url };
    }

    getComputedBreadcrumbs() {
        const configBreadcrumbs = Array.isArray(this.props.config.breadcrumbs)
            ? [...this.props.config.breadcrumbs]
            : [];

        if (configBreadcrumbs.length > 1) {
            return configBreadcrumbs;
        }

        const fallbackCrumb = this.getArchiveFallback(
            this.props.breadcrumbs,
            configBreadcrumbs
        );

        if (fallbackCrumb) {
            return [...configBreadcrumbs, fallbackCrumb];
        }

        return configBreadcrumbs;
    }

    render() {
        const computedBreadcrumbs = this.getComputedBreadcrumbs();
        const hasBreadcrumbs = computedBreadcrumbs && computedBreadcrumbs.length > 1;
        const { config } = this.props;

        if (hasBreadcrumbs && !config.back_arrow) {
            return (
                <section className="content_top">
                    <BreadCrumbs
                        title={config.back_translation}
                        only_breadcrumbs={true}
                        back_arrow={config.back_arrow}
                        breadcrumbs={this.props.breadcrumbs}
                        newBread={computedBreadcrumbs}
                    />
                </section>
            );
        } else if (config.back_arrow && hasBreadcrumbs) {
            return (
                <section className="content_top">
                    <BreadCrumbs
                        title={config.back_translation}
                        both={true}
                        back_arrow={config.back_arrow}
                        breadcrumbs={this.props.breadcrumbs}
                        newBread={computedBreadcrumbs}
                    />
                </section>
            );
        } else if (config.back_arrow) {
            return (
                <section className="content_top">
                    <BreadCrumbs
                        title={config.back_translation}
                        back_arrow={true}
                        breadcrumbs={this.props.breadcrumbs}
                        newBread={computedBreadcrumbs}
                    />
                </section>
            );
        } else {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Components/Content/Top/index.js